/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import { Linking } from 'react-native';
import { SplitBox, TextWrap as Text, View, styles as sc } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets
import useWindowDimensions from '../../hooks/useWindowDimensions';
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';
import { SubscriptionBox } from '../../components/site-components/SubscriptionBox';

export default function Checkout({ navigation }: RootStackScreenProps<'Checkout'>) {
  const screenDimensions = useWindowDimensions();

  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View>
        <View style={{ height: 20 }} />
        <Text style={sc.h2}>Join Now</Text>
        <Text style={[sc.blockParagraph, { fontSize: 24, marginTop: 15, marginHorizontal: 10, padding: 10 }]}>
          Start tracking meals in seconds instead of minutes.
        </Text>
        <Text style={[sc.blockParagraph, { fontSize: 18, marginTop: 15, marginHorizontal: 10, padding: 10 }]}>
          Try SnapCalorie free with a 7 day trial and then pay:
        </Text>
        <SplitBox
          flex={[0.45, 0.1, 0.45]}
          mobileView={screenDimensions.width < 800}
          style={{
            width: '90%',
            paddingTop: 50,
            alignSelf: 'center',
          }}
          key="SplitBox"
        >
          <SubscriptionBox
            title="YEARLY"
            cost="$12.50"
            period="Month"
            description="$149 billed yearly."
            onSubmit={() => {
              Linking.openURL('https://buy.stripe.com/5kA6qV3KF2Lq8SI28j');
            }}
            discountPercent={70}
          />
          <View style={{ height: 30 }} />
          <SubscriptionBox
            title="MONTHLY"
            cost="$29"
            period="Month"
            description="$29 billed monthly."
            onSubmit={() => {
              Linking.openURL('https://buy.stripe.com/14kcPj5SN2Lq8SI00c');
            }}
          />
        </SplitBox>
        <Text style={[sc.blockParagraph, { fontSize: 14, marginTop: 15, maxWidth: 420, textAlign: 'center' }]}>
          Cancel anytime. If you cancel before the end of the 7 day free trial you will not be charged.
        </Text>
      </View>
    </SnapCalorieSitePage>
  );
}
